/* eslint-disable import/prefer-default-export */

import { useRef, useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useLoggedInUser = () => {
  const loggedInUser = useSelector(state => state.AppState.user);

  const validRolesRef = useRef(['superAdmin', 'companyGroupAdmin', 'companyGroupManager']);

  const hasUserPermissionToChange = useMemo(() => {
    const { role } = loggedInUser;
    const { current: validRoles } = validRolesRef;
    const userIsPermittedToChange = new Set(validRoles);
    return userIsPermittedToChange.has(role);
  }, [loggedInUser]);

  return {
    loggedInUser,
    hasUserPermissionToChange,
  };
};
